import { ReactNode } from 'react';

import { usePageTitle } from 'hooks/html';

interface TitleProps {
  children: ReactNode;
  title?: string;
}

export function PageTitle({ title, children }: TitleProps) {
  usePageTitle(title);

  return <>{children}</>;
}
